<template>
  <div class="eventusers-box">
    <el-button
      type="text"
      class="goback"
      icon="el-icon-back"
      @click.native="goBack"
      >Back</el-button
    >
    <div class="groupfollower-title1">
      Send notification to events followers:
    </div>
    <el-input
      type="textarea"
      class="activity-cont"
      v-model="userParams.content"
    ></el-input>

    <div class="footer">
      <el-button @click.stop="sendgroupEventMessage">Send</el-button>
    </div>
    <div class="myinfo-mid-content" v-loading="loading">
      <div class="list-head">
        <div class="flex_6">Event Details</div>
      </div>

      <div
        class="list-content"
        v-for="(item, index) in eventUserList"
        :key="index"
      >
        <div class="flex_5">
          <img
            class="info-img"
            :src="item.covey_user ? item.covey_user.photo : ''"
          />
          <div class="info-detail">
            <div class="detail-title">
              {{ item.covey_user ? item.covey_user.realname : "" }}
            </div>
            <el-tooltip
              effect="light"
              :content="item.covey_user ? item.covey_user.desc : ''"
              placement="bottom-start"
            >
              <div class="detail-content">
                {{ item.covey_user ? item.covey_user.desc : "" }}
              </div>
            </el-tooltip>
          </div>
        </div>
        <div class="flex_1">
          <i
            class="fa fa-commenting-o"
            @click="contactPeople(item.user_id)"
          ></i>
        </div>
      </div>
      <div v-if="eventUserList.length < 5">
        <div
          class="list-content"
          v-for="index in 5 - eventUserList.length"
          :key="index"
        >
          <div class="flex_5"></div>
          <div class="flex_1"></div>
        </div>
      </div>
    </div>
    <KtPag
      :pageCount="pageParams.pageCount"
      :limit="pageParams.limit"
      :currentPage="pageParams.page"
      @onChange="handleChange"
    ></KtPag>
  </div>
</template>

<script>
import KtPag from "@/views/Comm/KtPag";
export default {
  components: {
    KtPag,
  },
  data() {
    return {
      eventUserList: [],
      pageParams: { page: 1, limit: 5, pageCount: 0 },
      c_id: "",
      loading: false,

      userParams: { content: "" },
    };
  },
  created() {
    this.c_id = this.$route.query.c_id;
  },
  mounted() {
    this.getGroupEventJoinedUser();
  },
  methods: {
    handleChange({ page, limit }) {
      this.pageParams = Object.assign({}, this.pageParams, { page, limit });
      this.getGroupEventJoinedUser();
    },
    goBack() {
      this.$router.push("/groupInfo/groupevents");
    },
    contactPeople(id) {
      if (id) {
        let routeData = this.$router.resolve({
          path: "/chat?contactId=" + id,
        });
        window.open(routeData.href, "_blank");
      }

      //   this.chatVisible = true;
    },
    async getGroupEventJoinedUser() {
      this.loading = true;
      let params = { ...this.pageParams };
      params["c_id"] = this.c_id;
      const { status, data, message } =
        await this.$api.courseApi.getGroupEventJoinedUser(params);
      if (status === "0") {
        this.eventUserList = data.rows;
        this.pageParams.pageCount = data.count;
      } else {
        this.$message({
          type: "error",
          message: message,
        });
      }
      this.loading = false;
    },
    //

    async sendgroupEventMessage() {
      let params = { ...this.userParams };
      params["c_id"] = this.c_id;
      if (!params.content) {
        this.$message({
          type: "warning",
          message: "Please fill in the content of the notification",
        });
        return;
      }
      const { status, message } =
        await this.$api.courseApi.sendgroupEventMessage(params);
      if (status === "0") {
        this.$message({
          type: "success",
          message: "Successfully post",
        });
        this.userParams = { activityContent: "" };
      } else {
        this.$message({
          type: "error",
          message: "Failed to send notification",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/utils/vw.scss";
.eventusers-box {
  padding: 24px;
  box-sizing: border-box;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.08);

  /deep/ .el-textarea__inner {
    height: vh(245);
    padding: 14px 16px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #181d2c;
    line-height: 20px;
  }

  .footer {
    text-align: right;
    padding-top: vh(24);
    .el-button {
      width: vw(100);
      height: vw(40);
      background: #f48c06;
      border-radius: 4px;
      color: #ffffff;
      font-weight: 500;
      font-size: 14px;
      border: none;
      outline: none;
      &:hover {
        opacity: 0.54;
      }
    }
  }

  .groupfollower-title1 {
    height: vh(25);
    font-size: vh(18);
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #181d2c;
    line-height: vh(25);
    margin-bottom: vh(20);
  }
  .goback {
    color: #f48c06;
  }
  .kt-page {
    text-align: right;
  }
  .myinfo-mid-content {
    // margin-top: vw(32);
    // box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.04);
    // border-radius: 24px;
    // background: #ffffff;
    .flex_1 {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      .fa-commenting-o {
        font-size: 24px;
        color: #f48c06;
        cursor: pointer;
      }
      .realnameimg {
        width: 12px;
        height: 12px;
        margin-right: 5px;
      }
      .realname {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #181d2c;
      }
      .price {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #181d2c;
      }
      .price_text {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #f48c06;
      }
      .checkbt {
        color: #fff;
        border: none;
        outline: none;
        background: #f48c06;
        &:hover {
          opacity: 0.54;
        }
      }
    }
    .flex_5 {
      flex: 5;
    }
    .list-head {
      height: vh(40);
      line-height: vh(40);
      font-size: 18px;
      font-weight: 500;
      color: #181d2c;
      box-sizing: border-box;
      padding-left: vw(10);
    }
    .list-content {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      height: vh(120);
      padding: vh(24) 0;
      box-sizing: border-box;
      border-top: 1px solid #dbd9d6;
      font-size: 14px;
      .info-img {
        width: 72px;
        height: 72px;
        border-radius: 8px;
        display: inline-block;
      }
      .info-detail {
        width: calc(100% - 72px);
        display: inline-block;
        padding-left: vw(16);
        box-sizing: border-box;
        .detail-title {
          height: vh(24);
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #181d2c;
          line-height: vh(24);
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .detail-content {
          height: vh(48);
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #181d2c;
          line-height: vh(24);
          display: -webkit-box;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
    }
  }
}
</style>